import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'

import { useFormik } from 'formik'

import SettingContext from '@/product/context/setting/settingContext'

const FxRates = () => {
    const settingcontext = useContext(SettingContext)
    const {
        searchTableFetch,

        search_fetch_data,
    } = settingcontext

    const [tableBody, setTableBody] = useState([])

    const formikView = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            primaryTable: 'fx_rates',
            orderby: 'fx.id,desc',
            filters: true,
        },
        onSubmit: (values) => {
            searchTableFetch(values, 'fxRate')
        },
    })

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data?.from === 'fxRate') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        searchTableFetch(formikView.values, 'fxRate')
    }, [])

    const tableValues = [
        // {
        //     field: 'id',
        //     type: '',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'ID',
        //     filterable: true,
        //     filterField: 'id',
        // },
        {
            field: 'currency',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Country Name',
            filterable: true,
            filterField: 'currency',
        },
        // {
        //     field: 'country_code',
        //     type: '',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Country Code',
        //     filterable: true,
        //     filterField: 'name',
        // },
        {
            field: 'fx_rate',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Currency Value',
            filterable: true,
            filterField: 'name',
        },
        {
            field: 'created_at',
            type: 'datetime',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Created At',
            filterable: true,
            filterField: 'name',
        },
    ]

    return (
        <Layout>
            <div className="dashboard staticPages">
                <CustomTable
                    formik={formikView.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={[]}
                    allData={search_fetch_data}
                    changeTableFunction={searchTableFetch}
                    fromVariable={'fxRate'}
                />
            </div>
        </Layout>
    )
}
export default FxRates
